import util from '@bmp-vue/core/api/util'

const controller = 'GlobalConfiguration'
export default Object.assign({}, util.GetCrud(controller, null))
